










































































































































































































































































import {
  WorkflowFormFieldOptionTodo,
  IDepartment,
  IDepartmentData,
  IWorkflowFormFieldOptionData,
  IWorkflowFormFieldOptionTodo,
  IWorkflowFormFieldOptionTodoData,
  IWorkflowFormFieldOptionTodoTemplateData,
  IWorkflowFormSectionFieldData
} from '@/models';
import { ErrorManager } from '@/models/error';

import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { ALForm } from '@/common/component.types';

import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import {
  IFetchWorkflowFormFieldOptionTodosParams,
  IWorkflowFormFieldOptionTodosPayload
} from '@/services';
import { diffDeep } from '@/utils/helpers';
import { IUserData } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib/types/model/userData.types';
import { cloneDeep } from 'lodash';
import Proxyable from '@/mixins/proxyable';
import { AxiosError } from 'axios';

import EmployeeUserPicker from '@/components/employee/EmployeeUserPicker.vue';
import HRDepartmentPicker from '@/components/employee/hr/HRDepartmentPicker.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import WorkflowFormBuilderTodoTemplatePicker from './WorkflowFormBuilderTodoTemplatePicker.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

const baseMixins = mixins(auth, Proxyable);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    createForm: ALForm;
    editForm: ALForm;
  };
}

export enum Tabs {
  Existing,
  Create
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'WorkflowFormBuilderTodoDrawer',

    components: {
      EmployeeUserPicker,
      HRDepartmentPicker,
      ErrorAlert,
      WorkflowFormBuilderTodoTemplatePicker,
      ConfirmationDialog
    },

    inject: {
      isFormDisabled: {
        default: false
      }
    },

    props: {
      sectionField: Object as PropType<IWorkflowFormSectionFieldData>,
      selectedOption: Object as PropType<IWorkflowFormFieldOptionData>,
      templateId: Number,
      revisionId: Number
    },

    data() {
      return {
        Tabs,
        selectedOptionIndex: -1 as number,
        selectedTodoIndex: -1 as number,
        selectedTodoTemplate: null as null | IWorkflowFormFieldOptionTodoTemplateData,

        originalTodoTemplate: null as null | IWorkflowFormFieldOptionTodoTemplateData,

        formValid: false,
        editFormValid: false,
        formTodoTemplate: {} as IWorkflowFormFieldOptionTodoTemplateData,

        loading: false,
        errorMessage: '',
        detailErrorMessage: '',

        deleteDialog: false,

        requiredRules: [(v: string) => !!v || 'This field is required'],

        tabs: null
      };
    },

    computed: {
      ...mapGetters({
        formFieldOptionTodos:
          'workflowFormTemplate/getWorkflowFormFieldOptionTodos',
        getWorkflowFormTodoTemplateById:
          'workflowFormTemplate/getWorkflowFormTodoTemplateById',
        hrDepartments: 'hrDepartment/getHrDepartments',
        getOptionTodosBySectionFieldAndOptionId:
          'workflowFormTemplate/getOptionTodosBySectionFieldAndOptionId'
      }),

      formFieldOptionTodos(): IWorkflowFormFieldOptionTodo[] {
        return this.getOptionTodosBySectionFieldAndOptionId(
          this.sectionField.id,
          this.selectedOption.id
        );
      }
    },

    methods: {
      ...mapActions({
        fetchHrDepartments: 'hrDepartment/fetchHrDepartments',
        createWorkflowFormFieldOptionTodo:
          'workflowFormTemplate/createWorkflowFormFieldOptionTodo',
        createWorkflowFormTodoTemplate:
          'workflowFormTemplate/createWorkflowFormTodoTemplate',
        fetchWorkflowFormFieldOptionTodos:
          'workflowFormTemplate/fetchWorkflowFormFieldOptionTodos',
        updateWorkflowFormTodoTemplate:
          'workflowFormTemplate/updateWorkflowFormTodoTemplate',
        deleteWorkflowFormFieldOptionTodo:
          'workflowFormTemplate/deleteWorkflowFormFieldOptionTodo'
      }),

      validateForm(formRef: ALForm): boolean {
        let valid = false;
        if (formRef) {
          valid = formRef.validate();
        }
        return valid;
      },

      resetFormValidation(formRef: ALForm): void {
        if (formRef) {
          return formRef.resetValidation();
        }
      },

      openDialog(index: number) {
        this.selectedTodoIndex = index;
        this.deleteDialog = true;
      },

      closeFormTodoTemplate(index: number) {
        (this.formFieldOptionTodos[index]
          .todo_template as IWorkflowFormFieldOptionTodoTemplateData) = this.originalTodoTemplate!;
        this.selectedOptionIndex = -1;
      },

      editFormTodoTemplate(index: number) {
        this.selectedOptionIndex = index;
        this.originalTodoTemplate = cloneDeep(
          this.formFieldOptionTodos[index]
            .todo_template as IWorkflowFormFieldOptionTodoTemplateData
        );
      },

      closeDeleteDialog() {
        this.selectedOptionIndex = -1;
        this.selectedTodoIndex = -1;
        this.deleteDialog = false;
      },

      removeFieldTemplateOption() {
        this.clearAllErrors();
        this.loading = true;

        const params: IFetchWorkflowFormFieldOptionTodosParams = {
          templateId: this.templateId,
          revisionId: this.revisionId
        };

        this.deleteWorkflowFormFieldOptionTodo({
          params,
          id: this.formFieldOptionTodos[this.selectedTodoIndex!].id
        })
          .then(() => {
            this.closeDeleteDialog();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      closeTodoDrawer() {
        this.internalValue = false;
      },

      getDepartmentInfo(todo: IWorkflowFormFieldOptionTodoData) {
        return ((todo.todo_template as IWorkflowFormFieldOptionTodoTemplateData)
          .todo_department as IDepartment).departmentInfo;
      },

      async tryGetOrFetchDepartments(): Promise<IDepartment[]> {
        if (!this.hrDepartments || this.hrDepartments.length == 0) {
          this.clearAllErrors();
          await this.fetchHrDepartments().catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          });
        }
        return this.hrDepartments;
      },

      saveFormTodoTemplate(todo: IWorkflowFormFieldOptionTodoData) {
        this.clearAllErrors();
        this.loading = true;

        const payload = diffDeep(
          todo.todo_template,
          this.getWorkflowFormTodoTemplateById(
            (todo.todo_template as IWorkflowFormFieldOptionTodoTemplateData).id
          ),
          true
        ) as IWorkflowFormFieldOptionTodoTemplateData;

        if (payload.todo_department) {
          payload.todo_department = ((todo.todo_template as IWorkflowFormFieldOptionTodoTemplateData)
            .todo_department as IDepartmentData).id!;
        }
        if (payload.assignee) {
          payload.assignee = ((todo.todo_template as IWorkflowFormFieldOptionTodoTemplateData)
            .assignee as IUserData).id!;
        }

        this.selectedOptionIndex = -1;

        this.updateWorkflowFormTodoTemplate(payload)
          .then(() => {
            this.$forceUpdate();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => (this.loading = false));
      },

      async addNewFormTodoTemplate() {
        if (this.validateForm(this.$refs.createForm)) {
          this.formTodoTemplate.order = this.formFieldOptionTodos.length + 1;

          const todo = await this.createWorkflowFormTodoTemplate(
            this.formTodoTemplate
          );

          this.addWorkflowFormFieldOptionTodo(todo);

          this.resetFormValidation(this.$refs.createForm);
          this.formTodoTemplate = {} as IWorkflowFormFieldOptionTodoTemplateData;
        }
      },

      fieldOptionAlreadyExist(todo: IWorkflowFormFieldOptionTodoTemplateData) {
        const template = this.formFieldOptionTodos.find(
          (optionTodo: IWorkflowFormFieldOptionTodo) =>
            (optionTodo.todo_template as IWorkflowFormFieldOptionTodoTemplateData)
              .id == todo.id
        );

        return template;
      },

      async addWorkflowFormFieldOptionTodo(
        todo: IWorkflowFormFieldOptionTodoTemplateData
      ) {
        this.clearAllErrors();
        if (!todo || this.fieldOptionAlreadyExist(todo)) return;

        this.loading = true;

        try {
          const params: IFetchWorkflowFormFieldOptionTodosParams = {
            templateId: this.templateId,
            revisionId: this.revisionId,
            sectionFieldId: this.sectionField.id
          };

          const data = new WorkflowFormFieldOptionTodo({
            section_field: this.sectionField.id!,
            todo_template: todo.id!,
            field_option: this.selectedOption.id!
          });

          const payload = {
            params,
            data
          } as IWorkflowFormFieldOptionTodosPayload;
          await this.createWorkflowFormFieldOptionTodo(payload);

          this.selectedTodoTemplate = null;
        } catch (err) {
          const error = err as AxiosError;
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        } finally {
          this.loading = false;
        }
      },

      clearAllErrors() {
        this.detailErrorMessage = '';
        this.errorMessage = '';
      },

      genTodos() {
        this.clearAllErrors();
        const params: IFetchWorkflowFormFieldOptionTodosParams = {
          templateId: this.templateId,
          revisionId: this.revisionId,

          sectionFieldId: this.sectionField.id,
          fieldOptionId: this.selectedOption.id
        };

        this.loading = true;

        this.fetchWorkflowFormFieldOptionTodos({ params })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => (this.loading = false));
      }
    }
  });
